import { pdfjs } from "react-pdf";

export function setupPdfWorker() {
  pdfjs.GlobalWorkerOptions.workerSrc = `${
    process.env.PUBLIC_URL ?? ""
  }/static/js/pdf.worker.min.mjs`;
}
